export default __webpack_public_path__ + "static/media/ComposeMessageSequence.becface7.svg";